<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-6" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('config.add_closing') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameClosingSelected"
            :visible.sync="modals.read"
            width="70%"
            top="2%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('config.type_of_closing') }}:</strong>
                        </h6>
                        {{ rowData.closing_type_label }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('config.date_of_closing') }}:</strong>
                        </h6>
                        {{ rowData.closing_date }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('config.interval_of_closing') }}:</strong
                          >
                        </h6>
                        {{ rowData.interval }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{ $t('common_words.farm') }}:</strong>
                        </h6>
                        <el-tag type="info">{{ rowData.farm_name }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{ $t('common_words.user') }}:</strong>
                        </h6>
                        <el-tag type="info">{{ rowData.user_name }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{ $t('common_words.module') }}:</strong>
                        </h6>
                        <el-tag type="info">{{ rowData.module_name }}</el-tag>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at">
                <p class="text-white">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
          <el-dialog
            :title="title"
            :visible.sync="modals.create"
            width="70%"
            :close-on-click-modal="false"
          >
            <form>
              <div class="row">
                <div class="col-3">
                  <label class="text-transform-none">{{
                    $t('config.type_of_closing2')
                  }}</label>
                  <br />
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required-type shadow-sm"
                    size="large"
                    v-model="closingForm.closing_type"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="option in closing_types"
                      class="select-primary"
                      :value="option.type"
                      :label="option.label"
                      :key="option.type"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="col-3"
                  v-if="closingForm.closing_type == 'specific'"
                >
                  <div class="form-group has-label">
                    <label class="text-transform-none">{{
                      $t('common_words.select_farm')
                    }}</label>
                    <br />
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-farm shadow-sm"
                      size="large"
                      v-model="closingForm.farm_id"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="option in farms"
                        class="select-primary"
                        :value="option.id"
                        :label="option.name"
                        :key="`${option.id}_${option.name}`"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="col-7">
                  <div class="form-group has-label">
                    <label class="text-transform-none">{{
                      $t('common_words.select_the_module')
                    }}</label>
                    <br />
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-module shadow-sm"
                      size="large"
                      v-model="closingForm.module_id"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="option in modules"
                        class="select-primary"
                        :value="option.id"
                        :label="option.id + ' - ' + option.name"
                        :key="option.id + ' - ' + option.name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 py-0">
                  <p>{{ $t('config.select_type_interval') }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <el-radio-group v-model="closingForm.interval">
                    <el-radio-button
                      class="custom-radio-button"
                      :label="$t('common_words.week')"
                    ></el-radio-button>
                    <el-radio-button
                      class="custom-radio-button"
                      :label="$t('common_words.calendar')"
                    ></el-radio-button>
                  </el-radio-group>
                </div>
                <div class="col-3" v-if="closingForm.interval == 'Semana'">
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required-year shadow-sm"
                    size="large"
                    v-model.number="closingForm.year_sel"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in Object.keys(years).reverse()"
                      class="select-primary"
                      :value="Number(option)"
                      :label="`${$t('common_words.year')} ${option}`"
                      :key="index"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="col-3"
                  v-if="
                    closingForm.interval == 'Semana' && closingForm.year_sel
                  "
                >
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required-week shadow-sm"
                    size="large"
                    v-model="closingForm.week_sel"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="week in years[closingForm.year_sel]"
                      class="select-primary"
                      :value="week"
                      :label="`${$t('common_words.week')} ${week}`"
                      :key="week"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-4" v-if="closingForm.interval == 'Calendario'">
                  <el-date-picker
                    v-if="renderComponent"
                    class="shadow-sm"
                    :clearable="false"
                    v-model="rangeDate"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="-"
                    :start-placeholder="$t('common_words.initial_date')"
                    :end-placeholder="$t('common_words.final_date')"
                    :align="'right'"
                  >
                  </el-date-picker>
                </div>
              </div>
            </form>
            <hr />
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.confirm') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              filterable
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'closing_date', order: 'descending' }"
              :data="queriedData"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="80"
                :align="'center'"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="90"
                :label="$t('common_words.status')"
                :align="'center'"
                :sortable="true"
                :resizable="false"
              >
                <template slot-scope="scope">
                  <el-tag
                    :type="`${scope.row.deleted_at ? 'warning' : 'info'}`"
                    >{{
                      scope.row.deleted_at
                        ? $t('common_words.disable')
                        : $t('common_words.enable')
                    }}</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                v-if="isShow() || isUpdate() || isDelete()"
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="
                        `${
                          props.row.deleted_at
                            ? $t('common_words.activate')
                            : $t('common_words.deactivate')
                        }`
                      "
                      :class="`btn-${
                        props.row.deleted_at ? `info` : `danger`
                      } btn-simple btn-link custom-margin-actions`"
                      @click="
                        props.row.deleted_at
                          ? handleActivate(props.$index, props.row)
                          : handleDelete(props.$index, props.row)
                      "
                    >
                      <em
                        :class="`fa ${
                          props.row.deleted_at ? `fa-check-circle` : `fa-times`
                        } custom-size-fa-actions`"
                      ></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="//unpkg.com/element-ui/lib/index.js"></script>
<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import { RadioGroup, Radio, RadioButton } from 'element-ui';
import { Pagination as LPagination } from 'src/components/index';
import SweetAlert from 'src/class/Alerts';
import configTable from './closingsTable';
import Fuse from 'fuse.js';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import { MixinExport } from 'src/mixins/mixin-export';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from '../../../../i18n.js';

export default {
  components: {
    LPagination,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
  },

  computed: {
    ...configTable().Search,

    nameClosingSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },

    closing_types() {
      return [
        { type: 'global', label: i18n.t('common_words.global') },
        { type: 'specific', label: i18n.t('common_words.specific') },
      ];
    },
  },
  data() {
    return {
      closingForm: {
        user_id: this.$store.state.auth.user.id,
        business_id: this.$store.state.auth.user.business[0].id,
        closing_type: null,
        farm_id: null,
        interval: 'Semana',
        year_sel: null,
        week_sel: null,
      },
      title: null,
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        create: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
      farms: [],
      modules: [],
      years: [],
      weeks: [],
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    mixinMasters,
    MixinExport,
    MixinForm,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['forceRerender', 'setupTable'],
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    openModal(name) {
      if (name == 'create') {
        this.title = i18n.t('config.add_closing');
        this.$validator.reset();
        this.closingForm = {
          user_id: this.$store.state.auth.user.id,
          business_id: this.$store.state.auth.user.business[0].id,
          closing_type: null,
          farm_id: null,
          interval: 'Semana',
          year_sel: Number(moment().format('Y')),
          week_sel: parseInt(moment().format('w')),
        };

        let current = new Date();
        this.rangeDate = [
          new Date(current.setDate(current.getDate() - current.getDay())),
          new Date(current.setDate(current.getDate() - current.getDay() + 6)),
        ];
      }
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    validate() {
      if (this.closingForm.closing_type == null) {
        return this.validationInputsRequired('type');
      } else {
        if (
          this.closingForm.closing_type == 'specific' &&
          this.closingForm.farm_id == null
        ) {
          return this.validationInputsRequired('farm');
        } else {
          if (this.closingForm.module_id == null) {
            return this.validationInputsRequired('module');
          } else {
            if (this.closingForm.interval == 'Calendario') {
              delete this.closingForm.closing_week;
              this.closingForm.closing_days = {
                initial_date: moment(this.rangeDate[0]).format('YYYY-MM-DD'),
                end_date: moment(this.rangeDate[1]).format('YYYY-MM-DD'),
              };
            } else {
              delete this.closingForm.closing_days;
              this.closingForm.closing_week =
                parseInt(this.closingForm.year_sel) * 100 +
                this.closingForm.week_sel;
            }

            this.closingForm.closing_date = moment().format('YYYY-MM-DD');

            if (this.closingForm.closing_type == 'global')
              delete this.closingForm.farm_id;

            this.addEditClosing();
          }
        }
      }
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      this.title = i18n.t('config.edit_closing');
      this.closingForm = Object.assign({}, row);
      this.closingForm.route = 'closings';

      if (this.closingForm.closing_days) {
        delete this.closingForm.closing_week;
        this.closingForm.interval = 'Calendario';
        this.rangeDate = [
          this.closingForm.initial_date,
          this.closingForm.end_date,
        ];
      } else {
        delete this.closingForm.closing_days;
        this.closingForm.interval = 'Semana';
        this.$set(
          this.closingForm,
          'year_sel',
          parseInt((this.closingForm.closing_week + '').substring(0, 4))
        );
        this.$set(
          this.closingForm,
          'week_sel',
          parseInt((this.closingForm.closing_week + '').substring(4))
        );
      }

      if (this.closingForm.closing_type == 'global')
        delete this.closingForm.farm_id;

      this.errors.clear();
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.closingForm = row;
      SweetAlert.default(
        i18n.t('sweet_alert.closings.textpart1'),

        null,
        i18n.t('sweet_alert.closings.textpart2'),
        1
      ).then((result) => {
        if (result.value) this.deleteClosing();
      });
    },

    handleActivate(index, row) {
      this.closingForm = row;
      SweetAlert.default(
        i18n.t('sweet_alert.closings.textpart3'),
        null,
        i18n.t('sweet_alert.closings.textpart2'),
        1
      ).then((result) => {
        if (result.value) this.activateClosing();
      });
    },

    activateClosing() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.closingForm.route = 'closings/activate';
        Axios.updateMaster(this.closingForm)
          .then((response) =>
            this.modifyTable(1, this.closingForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    addEditClosing() {
      this.showHideLoading(true);
      if (this.closingForm.route == 'closings') {
        if (this.isUpdate()) {
          Axios.updateMaster(this.closingForm)
            .then((response) => {
              this.modifyTable(1, this.closingForm.id, response);
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          this.closingForm.route = 'closings';
          Axios.saveMaster(this.closingForm)
            .then((response) => {
              this.modifyTable(0, null, response);
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    deleteClosing() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.closingForm.route = 'closings';
        Axios.destroyMaster(this.closingForm)
          .then((response) =>
            this.modifyTable(1, this.closingForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      this.PDF({
        route: 'closings/pdf',
        name_file: 'cierres.pdf',
      })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      this.Excel({
        route: 'closings/excel',
        name_file: 'cierres.xlsx',
      })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table, Search } = configTable();
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('closings')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('farms/farms/only').then((response) => {
      this.farms = response.data.data;
      this.showHideLoading();
    });

    Axios.getMasters('modules/indexToClosing').then((response) => {
      this.modules = response.data.data;
      this.showHideLoading();
    });

    Axios.getMasters('calendars/getyearsbusiness').then((response) => {
      this.years = response.data;
      this.showHideLoading();
    });
  },

  mounted() {
    this.selectedItemOnMenu('closings');
  },

  destroyed() {
    this.deselectedItemOnMenu('closings');
  },
};
</script>
<style></style>
